import React from 'react';
import Button from '../../../generic-components/Button';
import Heading from '../../../generic-components/Heading';
import { UserMessage } from '../../../DesignSystem/LiliUserMessage/UserMessage';
import { ReactComponent as XIcon } from '../../../assets/svg/x-icon-v2.svg';

interface IProps {
  closePopUp: () => void;
  supplierName: string;
  handleDelete: () => void;
}

export const DeleteConfirmation = ({ closePopUp, supplierName, handleDelete }: IProps) => (
  <UserMessage onClick={closePopUp} id='confirmCloseMessage'>
    <div className='w-[428px] py-[24px] bg-bw00 px-[24px] rounded-[8px] border border-bw03 relative flex flex-col'>
      <Button
        onClick={closePopUp}
        childElement={<XIcon className='stroke-bw08 w-[20px] hover:stroke-red02' />}
        className='absolute right-[12px] top-[12px]'
        id='closeConfirmation'
      />
      <Heading
        title={`Delete ${supplierName}?`}
        className='font-metricR text-[24px] text-bw08 leading-[130%] mb-[8px]'
      />
      <Heading
        title={`Are you sure you want to delete ${supplierName} from your recipient list?`}
        className='font-metricR text-[16px] text-bw07 leading-[128%] mb-[26px]'
      />
      <div className='w-full flex items-center justify-end gap-[12px]'>
        <Button
          shouldInvertLoaderColor
          onClick={closePopUp}
          className='bg-bw02 py-[11px] px-[40px] font-metricR text-[14px] text-action03 rounded-[4px]'
          title='Cancel'
          id='stayOnPage'
        />
        <Button
          onClick={handleDelete}
          className='bg-red02 py-[11px] px-[40px] font-metricR text-[14px] text-bw00 rounded-[4px]'
          title='Delete'
          id='leavePage'
        />
      </div>
    </div>
  </UserMessage>
);
